import styled from "styled-components";
import Marquee from "react-fast-marquee";
import { MOBILE_WIDTH } from "../../constants";

export const InfoBoxContainer = styled.div`
  height: 64px;
  width: auto;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 32px;
  padding-top: 24px;
  padding-bottom: 24px;
  @media ${MOBILE_WIDTH} {
    padding: 16px;
  }
`;

export const TitleContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Title = styled.h5`
  font-family: Oswald;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  color: #000000;
  margin: 0;
`;

export const Subtitle = styled.a`
  font-family: Oswald;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #000000;
  margin: 0;
  width: fit-content;
  :hover {
    opacity: ${(props) => (props.$hover ? "0.6" : "1")};
    cursor: ${(props) => (props.$hover ? "pointer" : "")};
  }
`;

export const StyledMarquee = styled(Marquee)`
  :hover {
    opacity: ${(props) => (props.$hover ? "0.6" : "1")};
  }
`;

export const LinksContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
